var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 440.8,
    cy: 440.4,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.5,556.7H81.8L162.1,324h63.4l80.2,232.7H253l-58.3-179.5h-1.8L134.5,556.7z M131.2,465.3h124.5v38.4 H131.2V465.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.2,324h60.7L447,480.4h2.7L513.8,324h60.7v232.7h-47.7V405.3h-1.9l-60.2,150.3h-32.5l-60.2-150.9h-1.9v152 h-47.7V324z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.9,556.7h-82.5V324h83.2c23.4,0,43.6,4.6,60.5,13.9c16.9,9.3,29.9,22.6,39,39.9 c9.1,17.3,13.7,38.1,13.7,62.3c0,24.2-4.6,45.1-13.7,62.5c-9.1,17.4-22.2,30.8-39.2,40.1C729.9,552.1,709.5,556.7,685.9,556.7z  M652.6,514.6h31.2c14.5,0,26.8-2.6,36.8-7.8c10-5.2,17.5-13.3,22.5-24.2c5-10.9,7.6-25.1,7.6-42.4c0-17.2-2.5-31.2-7.6-42.2 c-5-10.9-12.5-18.9-22.4-24.1c-9.9-5.2-22.2-7.7-36.7-7.7h-31.4V514.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmdIcon);
export default __webpack_public_path__ + "static/media/amd_icon.c629af5ce1677fa426cb900e8e996afa.svg";
export { ForwardRef as ReactComponent };